import {charcoal} from '../../sass/v2/_exports.sass';

export const ItalicTextIcon = ({color = charcoal, className = '', ratio = 1}) => {
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};
  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Italic text</title>
      <path
        d="M7.19272 24.8333V22.4231H12.2824L16.6031 9.57699H11.5134V7.16666H23.7184V9.57699H19.0387L14.7184 22.4231H19.3977V24.8333H7.19272Z"
        fill={color}
      />
    </svg>
  );
};
